import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import * as QRCode from 'qrcode';
import { BehaviorSubject, from, of, switchMap } from 'rxjs';

@Component({
    selector: 'qr-code',
    imports: [
        AsyncPipe,
    ],
    template: `
        @if (src | async; as s) {
            <img [src]="s">
        }
    `,
})
export class QrCodeComponent {

    private _text = new BehaviorSubject<string | null>(null);

    @Input() set text(value: string | null) {
        this._text.next(value);
    }

    src = this._text.pipe(switchMap(text => {
        if (!text) {
            return of(null);
        }
        return from(QRCode.toDataURL(text, { margin: 0, errorCorrectionLevel: 'Q' }));
    }));
}
